import React from 'react';
import { useNavigate } from '@tanstack/react-router';
import { FormattedMessage, useIntl } from 'react-intl';

import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import FloatingActionButton from '@mui/material/Fab';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import { useTheme } from '@mui/material/styles';
import AddIcon from '@mui/icons-material/Add';
import { useRoutes } from '~/hooks/api/useRoutes';

import ContentView from '~/components/ContentView';
import DrawerButton from '~/containers/DrawerButton';
import messages from './messages';
import Chip from '@mui/material/Chip';

export const RouteList: React.FC = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const intl = useIntl();
  const { data: routes = [], isLoading: isFetching } = useRoutes();

  const createRoute = () => {
    navigate({ to: '/trolley-routes/new' });
  };

  const editRoute = (id: number) => {
    navigate({
      to: '/trolley-routes/$routeId',
      params: { routeId: String(id) },
    });
  };

  return (
    <ContentView
      header={
        <AppBar position="static">
          <Toolbar>
            <DrawerButton />
            <Typography
              variant="h6"
              style={{ marginLeft: theme.spacing(2) }}
              sx={{
                color: 'inherit',
              }}
            >
              <FormattedMessage {...messages.title} />
            </Typography>
          </Toolbar>
        </AppBar>
      }
      floatingActionButton={
        <FloatingActionButton onClick={createRoute} color="secondary">
          <AddIcon />
        </FloatingActionButton>
      }
      isLoading={isFetching}
    >
      <List>
        {routes.map((route) => (
          <ListItem key={route.id} disablePadding>
            <ListItemButton onClick={() => editRoute(route.id)}>
              <ListItemText
                primary={route.name}
                secondary={intl.formatMessage(messages.onSiteLocation, {
                  meetingPlace: route.meetingPlace,
                })}
              />
              {route.isSuspended && (
                <Chip
                  label={intl.formatMessage(messages.deactivated)}
                  color="default"
                  size="small"
                />
              )}
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </ContentView>
  );
};

export default RouteList;
